import { t } from 'i18n'
import { AssumedInjuryV2 } from 'store/ducks'

export const InjuryTitle = ({
  injury,
  full = false
}: {
  injury: AssumedInjuryV2
  full?: boolean
}) => {
  const isCondition =
    injury.assumedInjury === 'dead' || injury.assumedInjury === 'acuteSickness'

  const baseLabel = injury.injuredBodyPart
    ? t(injury.injuredBodyPart as any)
    : t(isCondition ? 'condition' : 'injury')

  const titleParts = [
    baseLabel,
    injury.assumedInjury ? t(injury.assumedInjury as any) : undefined,
    full &&
      [
        injury.side ? t(`${injury.side}Side`) : undefined,
        injury.orientation ? t(`${injury.orientation}Orientation`) : undefined
      ]
        .filter(Boolean)
        .join('/')
  ].filter(Boolean)
  const title = titleParts.join(' • ')

  return <>{title}</>
}
